import { getMicroserviceBaseContext } from '../../constants/api-routing';

const evaluationContext = getMicroserviceBaseContext('evaluation');

export const EVALUATION_SERVICE = {
    // fetchFeedbackStatusMetadataList: `${evaluationContext}fetch_feedback_status_metadata_list`,
    // botEvalWithFeedback: `${evaluationContext}bot_eval_with_feedback`,
    updateFeedbackActivityLog: `${evaluationContext}update_feedback_activity_log`,
    fetchBotEvalHeadersDescription: `${evaluationContext}fetch_bot_eval_headers_description`,
    fetchIssuesLabelMetadataList: `${evaluationContext}fetch_issues_label_metadata_list`,
    getResponseFeedbackList: `${evaluationContext}response_feedback_list`,
}
